export const nl = {
  subscribe: {
    upgrade_subscription: 'Upgrade mijn abonnement',
    superpowers: 'Geef Plann3r Superkrachten',
    plus: 'PLUS',
    plus_price: '€3 / Maand',
    one_meeting_page: '1 Meeting Pagina',
    link_multiple: 'Koppel meerdere personen aan een pagina',
    unlimited_integrations:
      'Verscheidene integraties met tools zoals Zapier, ...',
    start_trial: 'Start Gratis Proefperiode',
    professional: 'PROFESSIONAL',
    professional_price_monthly: '€9,99 / maand',
    or: 'of',
    professional_price_yearly: '€99 / jaar',
    multiple_pages: 'Meerdere meeting pagina\'s',
    multiple_persons: 'Link meerdere personen aan een pagina',
    integrations:
      'Ongelimiteerde integraties met CRM\'s, automatiesoftware, ...',
    multiple_companies: 'Maak meerdere bedrijven aan',
    support: 'Prioriteitsondersteuning',
    trial_monthly: 'Start Gratis Proefperiode - maandelijks',
    trial_yearly: 'Start Gratis Proefperiode - jaarlijks',
  },
  settings: {
    company: {
      invalid_email_error: 'Ongeldig e-mailadres',
      employees: 'Werknemers',
      name: 'Naam',
      admin: 'Administrator',
      status: 'Status',
      yes: 'ja',
      make_admin: 'Maak Administrator',
      pending: 'Hangend',
      delete: 'verwijder',
      someone: 'iemand',
      add_employee: 'Voeg werknemer toe',
      page_name_error:
        'Er bestaat al een pagina met deze naam. Gelieve een andere naam te gebruiken.',
      page_length_error:
        'Een pagina naam moet tussen de 1 en 25 karakters bevatten.',
      page_character_error:
        'Een pagina naam kan enkel letters en nummers bevatten.',
      pages: 'Pagina\'s',
      edit: 'Aanpassen',
      go_to_editor: 'Pagina editor',
      save_before: 'Gelieve de nieuwe pagina op te slaan voor u deze aanpast.',
      share_link: 'Deel link',
      add_page_placeholder: 'Pagina naam, e.g. rekruteringspagina',
      add_page: 'Voeg een pagina toe',
      edit_pages: 'Pagina\'s: aanpassen van',
      back: 'Terug',
      unconfirmed: 'niet geconfirmeerd',
      delete_page_employee: 'verwijder',
      page_employee_name: 'Naam',
      page_employee_required: 'Verplicht',
      not_an_employee:
        'We herkennen deze medewerker niet. Ga naar uw bedrijfsinstellingen om deze persoon eerst aan uw bedrijf toe te voegen.',
      delete_confirmation:
        'Ben je zeker dat je deze pagina volledig wil verwijderen?',
      something_went_wrong:
        'Oeps, er ging iets verkeerd. Gelieve opnieuw te proberen.',
      file_size_alert: 'Het bestand moet kleiner dan 2MB zijn.',
      file_extension_alert: 'Dit bestandstype wordt niet ondersteund.',
      dont_save: 'Niet opslaan voor de upload voltooid is.',
      page_name_label: 'Naam',
      page_name_placeholder: 'Sales pagina',
      people_label: 'Personen',
      people_placeholder: 'Naam of e-mailadres',
      people_add: 'Voeg toe',
      colors: 'Kleuren',
      primary_color_label: 'Primaire Kleur',
      primary_color_placeholder: 'Primaire Kleur',
      secondary_color_label: 'Secundaire Kleur',
      secondary_color_placeholder: 'Secundaire Kleur',
      delete_page: 'Verwijder Pagina',
      company_info: 'Bedrijfsinformatie',
      change_logo: 'Verander logo: ',
      dont_save_logo: 'Gelieve niet op te slaan voor de upload voltooid is.',
      info_name_label: 'Naam',
      info_name_placeholder: 'Bedrijfsnaam',
    },
    settings: {
      integrations: 'Integraties',
      connect_to: 'Connecteer met',
      unlink: 'Ontkoppel',
      calendars: 'Kalenders',
      update_availability_error:
        'De beschikbaarheid kon niet aangepast worden...',
      update_days_error: 'De beschikbare dag kon niet aangepast worden...',
      update_information_error: 'Uw informatie kon niet aangepast worden...',
      labels: {
        information: 'Mijn Informatie',
        preferences: 'Mijn Voorkeuren',
        pages: 'Mijn Pagina\'s',
        integrations: 'Mijn Integraties',
        companies: 'Mijn Bedrijven',
        company: 'Mijn Bedrijf',
        data: 'Mijn Data',
        claim_company: 'Vraag meeting page aan',
      },
      upload_file_error:
        'Oeps, er ging iets fout. Gelieve opnieuw te proberen.',
      file_size_error: 'Bestand moet kleiner zijn dan 2MB.',
      file_type_error: 'Niet-ondersteunde bestandsextensie.',
      first_name_label: 'Voornaam',
      first_name_placeholder: 'Voornaam',
      last_name_label: 'Achternaam',
      last_name_placeholder: 'Achternaam',
      email_label: 'E-mail',
      email_placeholder: 'E-mail',
      phone_label: 'Telefoonnummer',
      phone_placeholder: 'Telefoonnummer',
      videocall_label: '(Video)Call link of naam',
      videocall_placeholder: '(Video)Call link of naam',
      timezone_label: 'Tijdzone',
      tier: 'Abonnement',
      upgrade_subscription: 'Upgrade abonnement',
      cancel_subscription: 'Annuleer abonnement',
      cancel_confirmation: 'Bent u zeker dat u uw abonnement wil annuleren?',
      location_label: 'Standaard Meeting Locatie',
      authentication_label: 'Authenticatiecode',
      authentication_placeholder: 'Authenticatiecode',
      save_button: 'Opslaan',
      saving: 'Bezig met opslaan',
      change_profile_picture: 'Verander uw profielfoto: ',
      dont_save: 'Niet opslaan zolang het uploaden niet voltooid is.',
      primary_calendar: 'Primaire Kalender',
      no_primary_calendar: 'Geen primaire kalender',
      add_calendar: 'Voeg een kalender toe',
      calendar_popup: {
        content_label: 'Voeg een kalendar toe',
        title: 'Voeg een kalendar toe',
        text:
          'Indien u meerdere werk/privé kalenders hebt, kan u deze hier toevoegen.',
        button: 'Link mijn kalender',
      },
      preferred_time: 'Voorkeurs meeting tijd',
      settings: 'Instellingen',
      new_tab: 'U wordt doorverwezen naar de pagina\'s.',
      my_data: 'Mijn  Data',
      data_statement:
        'Bij Plann3r schatten we jouw gegevens en privacy hoog in.',
      request_data: 'Vraag mijn gegevens op',
      request_information: 'Vraag Informatie',
      request_deletion: 'Verwijder mijn account',
      privacy: 'Privacy Policy',
      cookie: 'Cookie Policy',
    },
  },
  meeting: {
    mymeetings: {
      invited_by: 'Uitgenodigd door',
      view_more: 'Bekijk meer',
      to_be_determined: 'Te bepalen',
      declined: 'Geweigerd',
      no_moment_found: 'Geen moment gevonden',
      follow_up: 'PLAN EEN OPVOLGMEETING',
      settings: 'Instellingen',
      plan_meeting: 'Plan een meeting',
      pending_meetings: 'In Afwachting',
      no_meetings_yet: 'Geen meetings gepland zover.',
      current_meetings: 'Huidige Meetings',
      meeting_moment: 'Meeting tijdstip',
      history: 'Geschiedenis',
      meeting_date: 'Meeting tijdstip',
      meeting_created: 'Meeting gemaakt op',
    },
    meetingdetails: {
      confirm_deletion: 'Bent u zeker dat u de meeting wil verwijderen?',
      deletion_error:
        'Oeps, wij konden de meeting niet verwijderen. Probeer alstublieft opnieuw.',
      waiting_for: 'Wachtend op',
      accepted: 'Geaccepteerd',
      declined: 'Afgewezen',
      send_reminder: 'Stuur een reminder',
      permissions:
        'U heeft niet genoeg permissies om deze meeting uitnodiging te bekijken. Gelieve in te loggen met het juiste account.',
      return: 'Keer terug naar het meetingoverzicht.',
      description: 'Beschrijving: ',
      accept: 'Accepteer Automatisch',
      accept_manually: 'Kies tijdstip',
      decline: 'Weiger',
      invited_by: 'Uitgenodigd door: ',
      delete: 'Verwijder meeting',
      virtual_meeting: 'Virtuele Meeting',
      created_on: 'Meeting aangemaakt op',
      location: 'Locatie:',
      required: 'Verplicht',
      reminder_sent: 'Reminder is verstuurd.',
      reminder_error: 'Je kan voorlopig geen reminder versturen.',
    },
  },
  onboarding: {
    agendasstep: {
      title: 'Welkom bij Plann3r',
      description: 'Heb je meerdere kalenders? Voeg ze hier toe!',
      sign_in_google: 'Log in met Google',
      sign_in_exchange: 'Log in met Exchange',
      sign_in_office: 'Log in met Office 365',
      sign_in_icloud: 'Log in met iCloud',
      connected: 'Geconnecteerd',
      get_started_button: 'Laten we beginnen',
      email: 'E-mail',
      password: 'Wachtwoord',
      add_calendar_button: 'Voeg een kalender toe',
      agendas_explanation:
        'Plann3r zal de geselecteerde agenda\'s gebruiken voor het bepalen van je beschikbaarheid',
      select_agendas_button: 'Selecteer agenda\'s',
      next_button: 'Volgende',
      linked: 'Je hebt volgende kalenders gekoppeld',
      accept: {
        text: 'Ik accepteer de ',
        link: 'algemene voorwaarden',
      },
    },
    completed: {
      title: 'Hoe kan je Teamleader en Plann3r configureren?',
      step1: 'Stap 1) Activeer de Teamleader integratie in jouw Plann3r ',
      settings: 'instellingen',
      step2:
        'Stap 2) Ga naar “Mijn pagina’s” en maak je gratis bedrijf en meeting pagina aan.',
      step3:
        'Stap 3) Bewerk je meeting pagina. Je kan onder andere de kleuren, velden, logo en locatie aanpassen.',
      step4:
        'Stap 4) Om te selecteren welke Teamleader acties automatisch uitgevoerd moeten worden, klik je op de naam van je pagina en kies je dan rechtsboven voor voorkeuren. Onderaan de pagina kan je de actieve integraties terugvinden.',
      questions:
        'Als je vragen hebt, kan je onze support pagina hier bekijken, je kan met ons chatten of een email sturen naar',
      have_fun: 'Veel plezier met het inplannen van Meetings!',
      next: 'Wat nu?',
      congratulations: 'Proficiat met het voltooien van de registratie!',
      couple_of_things: 'Er zijn enkele zaken die je nu kan doen: ',
      claim: '- Claim een gratis meeting pagina',
      claim2: '(claim mijn pagina)',
      add_calendars: '- Voeg meer kalenders toe ',
      go_to_settings: '(ga naar instellingen)',
      last_step: 'Laatste Stap!',
      ready:
        'Je bent nu klaar om je gepersonaliseerde meeting pagina aan te maken.',
      i_want: 'Ik wil een gratis meeting pagina',
      settings_2:
        'Ik wil mijn instellingen aanpassen en extra kalenders toevoegen',
    },
    locationstep: {
      title: 'Standaard Meeting Locatie',
      default_location_explanation:
        'Vul hier jouw standaard locatie in. Tip: De standaard locatie is meestal je kantooradres.',
      explanation:
        'De standaard locatie zal gebruikt worden voor onze berekeningen indien we geen andere locatie vinden in jouw kalender.',
    },
    rangestep: {
      title: 'Voorkeurs meeting tijden',
      explanation:
        'Laat Plann3r weten wanneer je beschikbaar bent voor meetings. Je kan verschillende intervallen per dag toevoegen.',
    },
    namestep: {
      title: 'Aangenaam kennismaken!',
      description:
        'Vul hier jouw naam in zodat jouw genodigden de correcte informatie te zien krijgen.',
      first_name_label: 'Voornaam',
      first_name_placeholder: 'Jan',
      last_name_label: 'Achternaam',
      last_name_placeholder: 'Peeters',
      next_button: 'Volgende',
    },
    gifstep: {
      title: 'Uw kalender is succesvol gekoppeld!',
      description:
        'Vanaf nu kan Plann3r weten wanneer u niet beschikbaar bent!',
      description_2:
        'We hebben nog 3 korte vragen zodat wij volledig klaar zijn om meetings voor jou in te plannen.',
    },
    companystep: {
      company_name_existing: 'Vul de naam van jouw bedrijf in',
      company_name: 'Vul de naam van jouw bedrijf in',
      description_existing:
        'We sturen je een email wanneer de adminstrator van het bedrijf jouw aanvraag goedkeurt. U zal toegang krijgen vanaf hij/zij dat verzoek aanvaart.',
      description:
        'We zullen aan jouw bedrijf een eerste gratis personaliseerbare meeting pagina koppelen! Je kan latere eenvoudige meerdere pagina’s toevoegen.',
      tip: 'Tip: Freelancers vullen hier vaak hun eigen naam in',
      make_company: 'Maak mijn bedrijf aan!',
      add_to_company: 'Voeg me toe aan het bedrijf',
      existing_company:
        'Ik wil toegevoegd worden aan een reeds bestaand bedrijf',
      make_own_company: 'Ik wil mijn eigen bedrijf aanmaken.',
      thanks: 'Bedankt!',
      explanation:
        'We zullen u een email sturen wanneer u aan het bedrijf toegevoegd wordt.',
    },
    notloggedin: {
      message:
        'Je dient ingelogd te zijn om de onboarding te kunnen doorlopen.',
    },
    preferredtimestep: {
      title: 'Wanneer ben je beschikbaar voor meetings?',
      explanation:
        'Laat Plann3r weten welke dagen en uren je beschikbaar bent voor meetings. Je kan meerdere slots per dag toevoegen!',

      next_button: 'Volgende',
    },
  },
  pages: {
    pagesManagement: {
      step1: 'Voeg jouw bedrijf toe, wij maken dan jouw eerste pagina!',
      step2:
        'Stijl jouw persoonlijke pagina. Kleuren, extra velden, een mooi loog, ...',
      step3:
        'Beheer jouw pagina voorkeuren EN activeer de connectie met Teamleader',
    },
    companysettings: {
      something_went_wrong: 'Iets ging verkeerd, gelieve opnieuw te proberen.',
      file_too_big: 'Bestand is te groot.',
      unsupported_extension: 'Extensie wordt niet ondersteund.',
      invalid_email: 'Ongeldig email adres.',
      cannot_contain: 'Dat teken wordt niet ondersteund.',
      company_logo: 'Bedrijfslogo',
      choose_file: 'Kies een bestand',
      best_image: 'We raden aan om een vierkant logo te gebruiken.',
      company_name: 'Bedrijfsnaam',
      change_alert:
        'Het wijzigen van de bedrijfsnaam zorgt voor het wijzigen van alle pagina URL\'s',
      delete: 'Verwijder',
      someone: 'iemand',
      add_employee: 'Voeg werknemer toe',
      employees: 'Werknemers',
      unsaved_changes: 'U heeft onopgeslagen wijzigingen',
      saving_changes: 'Wijzigingen aan het opslaan',
      save_changes: 'Opslaan',
    },
    detail: {
      loading_text:
        'Uw pagina\'s worden geladen. Als dit te lang duurt, vernieuw de pagina dan even.',
      first_page:
        'Maak uw eerste pagina aan door het klikken van de \'Voeg bedrijf toe\' knop aan de linkerkant.',
      unsaved_changes: 'U heeft onopgeslagen wijzigingen',
      saving_changes: 'Wijzigingen aan het opslaan',
      save_changes: 'Opslaan',
      edit: 'Layout',
      preferences: 'Voorkeuren',
      availabilities: 'Beschikbaarheden',
      copied: 'Gekopieerd',
      copy_clipboard: 'Kopieer naar klembord',
    },
    editor: {
      alert_upload:
        'Er is iets fout gegaan tijdens het uploaden van u afbeelding. Gelieve opnieuw te proberen.',
      alert_file_smaller:
        'Gelieve een afbeelding te kiezen die kleiner is dan 5MB.',
      alert_unsupported_file:
        'Deze bestandsextensie wordt niet ondersteund. Worden ondersteund: .jpg/.jpeg/.png/.gif',
      theme: 'Thema',
      base_color: 'Basiskleur',
      accent_color: 'Accentkleur',
      logo: 'Logo',
      choose_file: 'Kies een bestand',
      generate: 'Genereer Logo in Huisstijl',
      best_to_pick: 'We raden aan om een vierkant logo te gebruiken.',
      heading: 'Hoofding',
      heading_placeholder: 'e.g. Plan een meeting met ...',
      displayName: 'Persoon / Bedrijf verantwoordelijk voor de afspraak',
      schedule_a_meeting_with: 'Plan een meeting met ',
      label: 'Label',
      example: 'Voorbeeld',
      required: 'Verplicht',
      remove: 'Verwijder',
      fields: 'Velden',
      add_field: 'Voeg een veld toe',
      address: 'Adres',
      add_another_office: 'Voeg een ander adres toe',
      option: 'Optie',
      info: 'Info',
      add_option: 'Voeg optie toe',
      guests_can_indicate: 'Uw gasten kunnen een adres doorgeven.',
      add_location: 'Voeg locatie toe',
      my_office: 'Mijn kantoor',
      duration: 'Soort Meeting',
      delete_duration: 'Verwijder soort meeting',
      add_duration: 'Voeg soort meeting toe',
      call_to_action: 'Tekst van knop',
      outro: 'Confirmatiebericht',
      call: 'Telefoon',
      their_office: 'Uw Kantoor',
      fetching:
        'We laden uw pagina\'s. Als het te lang duurt, vernieuw de pagina.',
    },
    master: {
      claim_alert: 'Er ging iets fout. Gelieve opnieuw te proberen.',
      settings: 'Bedrijfsinstellingen',
      add_page: 'Voeg Pagina toe',
      add_company: 'Voeg een bedrijf toe',
      meeting_pages: 'Meeting Pagina\'s',
      company_name: 'Bedrijfsnaam',
      placeholder: 'Tesla',
      add_company_button: 'Voeg bedrijf toe',
    },
    preferences: {
      meeting_assignment: 'Meeting Toewijzing',
      assignment_strategy: 'Toewijzing Strategie',
      assign_to: 'Wijs meeting toe aan ',
      all: 'IEDEREEN',
      persons: 'perso(o)n(en)',
      one_person: '1 persoon',
      round_robin: 'Round Robin',
      linked_to_page: 'Gelinkt aan de pagina',
      must: 'Moet steeds aanwezig zijn',
      might: 'Kan aanwezig zijn',
      not_an_employee:
        'We herkennen deze medewerker niet. Ga naar uw bedrijfsinstellingen om deze persoon eerst aan uw bedrijf toe te voegen.',
      one_linked:
        'Er moet aan deze pagina minstens één werknemer gekoppeld zijn. Gelieve één te koppelen voordat u iemand ontkoppelt.',
      unlink: 'Ontkoppel',
      page_name: 'Paginanaam',
      cannot_contain: 'Dat teken wordt niet ondersteund.',
      linked_employees: 'Gekoppelde Werknemers',
      people_placeholder: 'Naam of emailadres',
      people_add: 'Voeg toe',
      temporary_page: 'Tijdelijke pagina',
      temporary_explanation:
        'Een tijdelijke pagina kan gebruikt worden voor een specifiek evenement en zal alleen de momenten tonen binnen een specifiek tijdsinterval.',
      temporary_start: 'Start',
      temporary_end: 'Einde',
      temporary: 'Tijdelijk',
      autoaccept: 'Automatisch Accepteren',
      autoaccept_explanation:
        'Deze optie aanvinken zal er voor zorgen dat meeting uitnodigingen automatisch geaccepteerd zullen worden.',
      one_moment: 'Slechts 1 moment selecteerbaar',
      one_moment_explanation:
        'Men kan slechts 1 moment selecteren bij het aanvragen van de meeting in plaats van meerdere.',
      preferred_language: 'Voorkeurstaal',
      preferred_language_explanation:
        'Kies de taal waarin de communicatie naar uw pagina gebruikers gevoerd wordt.',
      buffer: 'Buffer',
      buffer_explanation: 'Hoeveel tijd wil je tussen meetings?',
      no_buffer: 'Geen buffer',
      fastest_possible: 'Vroegst mogelijk moment',
      fastest_possible_explanation:
        'Vanaf welk moment mag Plann3r momenten voorstellen?',
      immediately: 'Onmiddelijk',
      sequential: 'Sequentiële Meetings',
      sequential_explanation:
        'Wil je enkel sequentiële meeting blokken tonen? (Voorbeeld: voor meetings van 1 uur stellen 9:00, 10:00, 11:00 voor.',
      integrations: 'Integraties',
      integrations_explanation:
        'U kan uw pagina linken aan verscheidenen CRM\'s, tools, automatie services...',
      actions: 'Acties',
      on_request: 'Nadat een meeting aangevraagd is...',
      on_schedule: 'Nadat een meeting moment gevond is...',
      link_to: 'Koppel met deze integratie:',
      needs_reconnect: ' moet opnieuw verbonden worden.',
      connect_to: 'Koppel met',
      delete_page: 'Verwijder Pagina',
    },
    availabilities: {
      preferred_times: 'Beschikbaarheid voor deze meeting pagina',
      preferred_times_explanation:
        'Hier kan je speciale beschikbaarheden voor deze meeting pagina invullen. Als je hier niks toevoegt, zal Plann3r gebruik maken van je persoonlijke meetinsvoorkeuren en kalenderinformatie',
      add_range: 'Voeg interval toe',
      ignore_calendars: 'Negeer kalenders',
      ignore_calendars_explanation_1:
        'Deze optie selecteren zorgt er voor dat we bestaande kalenders zullen negeren bij het berekenen van passende meeting momenten.',
      ignore_calendars_explanation_2:
        'We nemen echter wel meetings in rekening die via Plann3r gepland zijn. (Deze optie wordt meestal gebruikt voor beurzen en conferenties)',
      preferred_timezone: 'Voorkeurs tijdzone',
    },
    preview: {
      preview: 'Pagina Voorvertoning',
      fetching: 'Laden...',
      duration: 'Soort meeting',
      location: 'Locatie',
      meeting_schedule: 'Plan een meeting met ',
      plan_date: 'Plan een date met ',
      required: '* Verplichte velden',
      my_office: 'Mijn Kantoor',
      call: 'Telefoon',
      your_office: 'Uw Kantoor',
      fill_in_address: 'Gelieve uw adres in te voeren',
      previewshow: {
        this_is: 'Dit is een',
        preview: 'voorbeeld',
        your_meeting: 'van hoe uw meeting pagina eruit zou zien.',
        here: 'Klik hier',
        live: ' om naar uw live vergaderingspagina te gaan.',
      },
    },
  },
  calendars: {
    planner_selected:
      'Plann3r gebruikt de geselecteerde agenda\'s hieronder om uw beschikbaarheid te bepalen',
    select: 'Selecteer Agenda\'s',
    no_content: 'No content.',
    linked_calender: 'U hebt deze agenda\'s gekoppeld:',
    icloud: {
      email: 'E-mail',
      email_placeholder: 'naam@example.com',
      password: 'Wachtwoord',
      add_calendar_button: 'Voeg een kalender toe',
    },
    using_exchange: {
      part1: 'Gebruikt u een Exchange bedrijfsserver of een andere agenda?',
      part2: 'Stuur een e-mail naar',
      part3: 'support@plann3r.com',
      part4: 'en we helpen je op weg.',
    },
    accept: {
      text: 'Ik accepteer de ',
      link: 'algemene voorwaarden',
    },
  },
  calendarspopup: {
    your_invitees: 'Je genodigden zien nooit wat er in je agenda staat.',
    privacy: 'PRIVACY POLICY',
  },
  header: {
    plan_meeting: 'Plan een meeting',
    features: 'Hoe werkt het?',
    pricing: 'Prijzen',
    contact: 'Contact',
    blog: 'Blog',
    login: 'Login',
    settings: 'Instellingen',
    meetings: 'Mijn Meetings',
    pages: 'Mijn Pagina\'s',
    logout: 'Uitloggen',
  },
  logout: {
    logging_out: 'Uitloggen...',
  },
  pluginpopup: {
    step1: 'Step 1: Login',
    step2: 'Step 2: Kopieer uw authenticatietoken',
    step3: 'Step 3: Gelukkige planning',
    copy: 'Copy',
  },
  privacy: {
    title: 'Privacy Policy',
    policy: {
      part1:
        ' Plann3r VOF, in this document also referred to as “Plann3r”, “we” or “us” values the importance of privacy. We provide this Privacy Policy to explain our services and how we collect, use and disclose information obtained from our users (“our users” refers to users of the Plann3r online platform, website plugins and all other Plann3r software,also referred to as “Plann3r Software).',
      part2:
        ' If you would have any questions regards to this Privacy Policy or how your data is treated please do contact us.',
      part3:
        'This Privacy Policy may be updated periodically. We will notify every user on the material changes by posting the new Privacy Policy on the Plann3r Website. Please consult the Plann3r Website regularly for changes.',
      part4:
        'By using our Plann3r Software you are consenting to Plann3r processing your information as described in this Privacy Policy and as would be amended by us. This may or may not include the collection, storage, disclosure, deletion and transfer of your information for the services you provided.',
    },
    title2: 'Collected Information',
    collected_info: {
      part1:
        'We collect the information provided by you, the user as well as the information provided by the use of Plann3r Software.',
      part2:
        'When scheduling a meeting with Plann3r, you voluntarily provide us with a certain set of information such as names, addresses, phone numbers (Non-exhaustive) for yourself as well as your invitees. Plann3r does not use this information for other purposes than the scheduling of meetings, improving our services and providing information on Plann3r.',
      part3:
        'You and your invitees may connect your third party calendar (iCloud, Microsoft Exchange,365, Gmail; Non-exhaustive) to Plann3r. Plann3r only connects to retrieve the calendar information necessary to find the perfect time to meet. We do not store this information, nor does Plann3r personnel know who you are meeting, for what purpose or any other confidential details about the meeting.',
      part4:
        'Permission for access to third party applications such as your Google and Microsoft mail account (non-exhaustive) are only used to obtain the information needed to schedule meetings at the appropriate time. For privacy policies or settings on these third party applications we refer you to their respective privacy and data handling policies, most commonly to be found on their product’s website.',
      part5:
        'With regards to billing information when obtaining a paid version of Plann3r, the third party payment processors will collect and store billing address and credit card data. Plann3r only stores four digits counted from the last digit backwards, as well as the expiration date provided.',
    },
    title3: 'Information Sharing',
    text1:
      'Web beacons cookies and other technologies may be used on our website to receive and store certain sets of information to ease the user’s experience as well as providing tailored marketing messages. Examples would be the function to automatically log in to Plann3r (“log data”), which may contain your web address, mobile network carrier, IP, time zone and location. This shared information can be disabled on the device you are using to access Plann3r with. Information on their respective privacy policies and data sharing can be found on their respective website. Plann3r is not responsible for any third party applications or device privacy issues.',
  },
  link: {
    almostdone: {
      meeting_schedule: 'Plan een meeting met ',
      plan_date: 'Plan een date met ',
      pick_moment: 'Kies een moment',
      required: '* Verplichte velden',
      please_fill:
        'Vul alle verplichte velden in. En zorg ervoor dat u een geldig e-mailadres opgeeft.',
      error: 'Oeps! Er is iets misgegaan...',
      duration: 'Soort Meeting',
      location: 'Locatie',
      my_office: 'Mijn Kantoor',
      fill_in_address: 'Gelieve uw adres in te voeren',
      call: 'Telefoon',
      your_office: 'Uw Kantoor',
      where: 'Waar ga je graag op date?',
      loading_calendars:
        'Wij kijken in de agenda(s) op zoek naar de best passende momenten. Even geduld aub.',
    },
    bestmoments: {
      done: 'Je bent nu klaar!',
      send_email:
        'We sturen u een e-mail wanneer de pagina eigenaar heeft geaccepteerd en wanneer het vergadermoment is gevonden.',
      recommended: 'Aanbevolen',
      free: {
        part1: 'Wilt u uw eigen',
        part2: 'gratis ',
        part3: 'Plann3r account?',
      },
      customise: ' Pas de beschikbaarheid aan',
      manage: 'Beheer je voorkeuren',
      send_invites: 'Stuur je eigen uitnodigingen',
      activate: 'Activeer mijn account',
      thanks: 'Bedankt voor het aanvragen van een meeting!',
      soon: 'Ik neem spoedig contact met u op!',
      next_up: 'Wat gebeurt er nu?',
      next_step1:
        'ontvangt een melding en kan jouw meeting verzoek accepteren of weigeren.',
      next_step2_a: 'Als de meeting geaccepteerd is, zal je een ',
      next_step2_b: 'confirmatiemail',
      next_step2_c: 'ontvangen met de',
      next_step2_d: 'datum en tijd',
      next_step2_e: 'van de meeting.',
      why_plann3r: 'Wil jij jouw eigen gratis Plann3r account?',
      plann3r_1: 'Meetings worden automatisch toegevoegd aan jouw kalender',
      plann3r_2: 'Maak jouw eigen gepersonaliseerde meeting pagina',
      plann3r_3:
        'Meetings worden alleen ingepland als jij écht beschikbaar bent',
      free_meeting_page: 'Ik wil een gratis meeting pagina',
    },
    chooseamoment: {
      when_available: 'Wanneer ben je beschikbaar?',
      duration: 'Duur: ',
      timezone: 'Tijdszone: ',
    },
    linkinvitation: {
      not_valid_url: 'Dit is geen geldige URL.',
      valid_key: 'U hebt geen geldige sleutel.',
      loading: 'Wij verwerken uw aanvraag. Dit kan enkele seconden duren...',
    },
    overview: {
      book: 'Boek nu',
    },
    who: {
      who_are_you: 'Wie ben je?',
      following_invitees: 'Welke van de volgende genodigden ben jij?',
      thats_me: 'Dat ben ik!',
    },
    meetingavailabilities: {
      select_moments: 'Selecteer één van de beschikbare momenten: ',
      moments_passed:
        'De beschikbare momenten zijn ondertussen gepasseerd. Gelieve contact op te nemen via: ',
    },
    availabilities: {
      at_least_one: 'Selecteer minstens 1 moment.',
      calculating: 'Bezig met het berekenen van passende meeting momenten...',
      times_shown: 'Tijdstippen worden getoond in de ',
      timezone: ' tijdszone.',
      please_select:
        'Gelieve meerdere momenten te selecteren. Dit zal ervoor zorgen dat we voor jou het beste moment om af te spreken kunnen vinden.',
      submit_button: 'Verzend Momenten',
      no_moments: 'Er werden geen passende momenten gevonden...',
      weekdays: ['MA', 'DI', 'WO', 'DO', 'VR', 'ZA', 'ZO'],
      months: [
        'JAN',
        'FEB',
        'MAA',
        'APR',
        'MEI',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OKT',
        'NOV',
        'DEC',
      ],
      step1: 'Stap 1: Selecteer een dag',
      step2_a: 'Stap 2: Selecteer momenten voor een meeting van',
      step2_b: 'minuten',
      step2_a_one_moment: 'Stap 2: Selecteer één moment voor een meeting van',
      best_moment: 'Beste moment ',
      best_moment_for: 'Beste moment voor ',
      other_moments: 'Andere momenten',
      pick_other_moment: 'Kies een ander moment',
      selected_moments: 'Geselecteerde momenten',
      selected_moment: 'Geselecteerd moment',
      multiple_moments: 'We raden je aan om meerdere momenten te selecteren.',
      send: 'Verzenden',
    },
  },
  components: {
    preferredtime: {
      remove: 'Verwijder',
      not_available_on: 'Je bent niet beschikbaar op',
      add_range: 'Voeg een meeting interval toe',
      monday: 'Maandag',
      tuesday: 'Dinsdag',
      wednesday: 'Woensdag',
      thursday: 'Donderdag',
      friday: 'Vrijdag',
      saturday: 'Zaterdag',
      sunday: 'Zondag',
    },
    save: {
      saved: 'Opgeslagen',
      claim: 'Neem deze pagina',
      saving: 'Opslagen',
      change_made: 'Veranderingen zijn gemaakt',
      save: 'Opslaan',
    },
    emailinput: {
      i_want: 'Ik wil afspreken met ... (e-mail)',
      valid_email: 'Vul alstublieft een geldig e-mailadres in.',
      fill_email: 'Vul alstublieft een e-mailadres in.',
      already_invited: 'Je hebt deze persoon al uitgenodigd.',
    },
    location: {
      meeting_address: 'Meeting adres',
    },
  },
}
